import React, { useContext } from 'react'
import { Link } from "react-router";
import { userContext } from '../components/Context'
import axios from 'axios'
import logo from '../logo.png'

export default function NavBar(){
  const ctx = useContext(userContext)

  const logout = () => {
    axios.get(
      '/logout',
      { withCredentials: true }
    ).then(res => {
      if(res.data === 'success'){
        window.location.href= '/login'
      } else {
        console.log(res)
      }
    }).catch(err => {
      console.log(err)
    })
  }

  return (
    <div className="navigation">
      <div className="logo">
        <img src={logo} alt="vStream Logo" />
      </div>
      {ctx ? (
        <>
          <Link to="/apps" className="nav-link">Apps</Link>
          <Link to="/groups" className="nav-link">Groups</Link>
          <Link to="/devices" className="nav-link">Devices</Link>
          <Link onClick={logout} to="/logout" className="nav-link">Logout</Link>
        </>
      ) : (
        <>
          <Link to="/login" className="nav-link">Login</Link>
        </>
      )}

    </div>
  )
}
